/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:768px){.iconDesign[_ngcontent-%COMP%]{font-size:26px;color:#fff;background-color:#952323;border-radius:100%;padding:10px}}@media (max-width:769px){.iconDesign[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
